import {
    TITLE_PREFIX,
    DASHBOARD_ROUTE,
    PICK_ROUTE,
    GROUP_PICK_ROUTE,
    PACK_ROUTE,
    WAVES_ROUTE,
    READY_FOR_PICKUP_ROUTE,
    HOSPITAL_ROUTE,
    CANCELLED_ROUTE,
    FINALIZED_ROUTE,
} from './consts';

export default () => ({
    main: {
        id: 'Dashboard',
        label: 'Dashboard',
        title: `${TITLE_PREFIX}`,
        link: DASHBOARD_ROUTE,
        permission: 'fulfillments.index',
        order: 10,
    },
    pick: {
        id: 'Pick',
        label: 'Pick',
        title: `${TITLE_PREFIX} > Pick`,
        link: PICK_ROUTE,
        permission: 'fulfillments.picking',
        order: 20,
    },
    groupPick: {
        id: 'Group Pick',
        label: 'Group Pick',
        title: `${TITLE_PREFIX} > Group Pick`,
        link: GROUP_PICK_ROUTE,
        permission: 'fulfillments.picking',
        order: 30,
    },
    waves: {
        id: 'waves',
        label: 'Waves',
        link: WAVES_ROUTE,
        title: `${TITLE_PREFIX} > Waves`,
        permission: 'fulfillments - waves.index',
        order: 40,
    },
    pack: {
        id: 'Pack',
        label: 'Pack',
        title: `${TITLE_PREFIX} > Pack`,
        link: PACK_ROUTE,
        permission: 'fulfillments.packing',
        order: 50,
    },
    ready: {
        id: 'Shipped',
        label: 'Shipped',
        title: `${TITLE_PREFIX} > Shipped`,
        link: READY_FOR_PICKUP_ROUTE,
        permission: 'fulfillments.index',
        order: 60,
    },
    hospital: {
        id: 'Hospital',
        label: 'Hospital',
        title: `${TITLE_PREFIX} > Hospital`,
        link: HOSPITAL_ROUTE,
        permission: 'fulfillments.hospital',
        order: 70,
    },
    cancelled: {
        id: 'Cancelled',
        label: 'Cancelled',
        title: `${TITLE_PREFIX} > Cancelled`,
        link: CANCELLED_ROUTE,
        permission: 'fulfillments.hospital',
        order: 80,
    },
    finalized: {
        id: 'finalized',
        label: 'Finalized',
        title: `${TITLE_PREFIX} > Finalized`,
        permission: 'fulfillments.index',
        link: FINALIZED_ROUTE,
        order: 90,
    },
});
